(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'AmexVerifyCard',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.success = function success(response)
	{
		var $modal = $('.modal');

		$('.qa-verification-results').html('');

		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		// show verification details
		Adzuki.Ajax.get('/AmexCardVerification/verificationResults')
		.then(function success(response) {
			$('.qa-verification-results').html(response);

			// show amenity modals
			$('.label.amenity').click(function showAmenity()
			{
				$modal.find('.modal-title').text('Amenity Information');
				$modal.find('.modal-body').html($(this).data('amenity'));
				$modal.modal('show');
			});
		});

		return false;
	};
}(jQuery, window.Adzuki || {}));
